export enum TranslationsZh {
  YEAR_MONTH_DAY = '{year}-{month}-{day}',
  MON = '周一',
  TUE = '周二',
  WED = '周三',
  THU = '周四',
  FRI = '周五',
  SAT = '周六',
  SUN = '周日',
  STREET_ADDRESS1 = '地址1',
  STREET_ADDRESS2 = '地址2',
  CITY = '城市',
  STATE = '州',
  ZIP_CODE = '邮编',
  COUNTRY = '国家',
  OK = '确定',
  CANCEL = '取消',
  CONFIRMATION = '确认',
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL = '确定要取消吗？',
  STEP = '步骤',
  OF = '的',
  PREVIOUS = '上一步',
  NEXT = '下一步',
  SAVE = '保存',
  SAVE_AND_NEXT = '保存并继续',
  SUBMIT = '提交',
  CLOSE = '关闭',
  ENLARGED_ATTACHMENT = '放大附件',
  NO_INFO = '没有信息',
  BEDROOMS = '卧室',
  BATHROOMS = '浴室',
  HOME = '家',
  PROGRESS = '进度',
  START_DATE = '开始日期',
  END_DATE = '结束日期',
  UNKNOWN = '未知',
  VIEW_ALL = '查看所有',
  FEET = '英尺',
  SUCCESS = '成功！',
  FINISH = '完成',
  SOMETHING_WENT_WRONG = 'Oops! 出错了！',
  EMAIL = '邮箱',
  UPLOAD_FILE = '上传文件',
  OPEN_FILE = '打开文件',
  BACK = '返回',
  TENANT_SIGN_IN = '租户登录',
  NO_RENTAL_HISTORY_ERROR = '请至少输入一个之前的租赁信息。',
  CANNOT_PERFORM_SCREENING = '目前无法进行背景调查。',
  CANNOT_MAKE_PAYMENTS = '目前无法进行付款。',
  STRIPE_COULD_NOT_BE_REACHED = '无法连接 Stripe，请稍后再试',
  PAYMENT_DECLINED = '您的付款被拒绝。请换一张卡或其他付款方式重试。',
  VIEW_SPECIFIC_REASON = '查看具体原因',
  PAYMENT_FAILED = '您的付款未成功。请重试。',
  PAYMENT_DECLINE_UNKNOWN = '我们无法完成这笔交易。请联系客服获取帮助。',
  PAYMENT_DECLINE_INVALID_REQUEST = '该付款请求无法按提交的内容受理。请联系客服获取帮助。',
  PAYMENT_DECLINE_INVALID_AMOUNT = '交易金额无效。请核对金额或联系客服。',
  PAYMENT_DECLINE_INVALID_VALUE = '提交的一项或多项信息无法受理。请核对信息或联系客服。',
  PAYMENT_DECLINE_UNAUTHORIZED = '付款请求因凭据未被接受而遭到拒绝。请联系客服获取帮助。',
  PAYMENT_DECLINE_FORBIDDEN = '不允许进行此次付款。请联系客服获取帮助。',
  PAYMENT_DECLINE_DUPLICATE_REQUEST = '这笔请求与此前的一笔重复。请先核对已有记录，再发起另一笔付款。',
  PAYMENT_DECLINE_TIMEOUT = '支付服务商未在规定时间内响应。请联系客服获取帮助。',
  PAYMENT_DECLINE_PROVIDER_UNAVAILABLE = '支付服务商暂时不可用。请联系客服确认这笔交易的结果。',
  PAYMENT_DECLINE_PROVIDER_ERROR = '我们无法完成这笔交易。请联系客服获取帮助。',
  PAYMENT_DECLINE_PROCESSING_LIMIT_EXCEEDED = '这笔交易超出了适用的支付处理限额。请联系客服确认允许的限额。',
  PAYMENT_DECLINE_PAYMENT_METHOD_LIMIT_EXCEEDED = '这笔交易超出了该付款方式的某项限额。请联系账户持有人确认适用的限额。',
  PAYMENT_DECLINE_PAYMENT_METHOD_VERIFICATION_FAILED = '我们无法验证该付款方式。请改用其他付款方式或联系客服。',
  PAYMENT_DECLINE_PAYMENT_METHOD_HOLDER_MISMATCH = '账户持有人信息无法匹配。请核对您在银行登记的信息，或改用其他付款方式。',
  PAYMENT_DECLINE_COLLECT_DECLINED = '您的银行未批准这笔付款。请联系您的银行或改用其他付款方式。',
  PAYMENT_DECLINE_COLLECT_INSUFFICIENT_FUNDS = '由于余额不足或超出信用额度，这笔付款未能完成。请联系账户持有人或改用其他付款方式。',
  PAYMENT_DECLINE_COLLECT_METHOD_INVALID = '该付款方式无法使用。请核对信息或改用其他付款方式。',
  PAYMENT_DECLINE_COLLECT_METHOD_EXPIRED = '该付款方式已过期。请改用其他付款方式。',
  PAYMENT_DECLINE_COLLECT_RESTRICTED = '该付款方式不允许进行此次付款。请联系您的银行或改用其他付款方式。',
  PAYMENT_DECLINE_COLLECT_REQUIRES_ACTION = '完成这笔付款还需要额外的操作。请联系客服获取帮助。',
  PAYMENT_DECLINE_KYC_REQUIRED = '这笔交易未能获得批准。请联系客服获取帮助。',
  PAYMENT_DECLINE_KYC_FAILED = '这笔交易未能获得批准。请联系客服获取帮助。',
  PAYMENT_DECLINE_RISK_REJECTED = '这笔交易未能获得批准。请联系客服获取帮助。',
  PAYMENT_DECLINE_SANCTION_RESTRICTED = '这笔交易未能获得批准。请联系客服获取帮助。',
  PAYMENT_DECLINE_INTERNAL_ERROR = '我们无法完成这笔交易。请联系客服获取帮助。',
  BUSINESS_INFO_NOT_FOUND = '商业信息缺失。',
  RENTAL_APPLICATION_NOT_FOUND = '找不到此租赁申请。',
  FILE_UPLOAD_FAILED = '文件上传失败，请重试。',
  FILE_NOT_ACCEPTED = '您的某个文件因类型或大小不符而无法上传。请将其移除后重试。',
  FILE = '文件',
  LEASE_INSURANCE_MISSING_FIELDS = '缺少必填信息，请填写所有字段后重试。',
  LEASE_OR_SIGNATURE_NOT_FOUND = '找不到此租约或签名。',
  FILE_SESSION_RESPONSE_INVALID = '无法开始文件上传，请重试。',
  REMOVE = '删除',
  APPLICANT_INFORMATION = '申请人信息',
  GET_STARTED = '您的资料',
  POTENTIAL_UNITS = '潜在单位',
  UNITS_OF_INTEREST = '感兴趣的单位',
  ALL_UNITS = '所有单位',
  OPEN_TO_ALL_UNITS = '对所有单位开放',
  RENTAL_HISTORY = '租赁历史',
  WORK_HISTORY = '工作历史和收入验证',
  TERM_AND_CONDITIONS = '条款和条件',
  CONFIRM_YOUR_IDENTITY = '确认你的身份',
  PETS_AND_CARS = '宠物和汽车',
  QUESTIONS = '问题',
  RENTAL_APPLICATION = '租赁申请',
  SUBMIT_A_RENTAL_APPLICATION = '提交租赁申请',
  MAGICDOOR_TERMS = 'MagicDoor 条款和条件',
  TRANS_UNION_TERMS = 'TransUnion 条款和条件',
  ADD_RENTAL_HISTORY = '添加租赁历史',
  REASON_FOR_LEAVING = '离开原因',
  LANDLORD_NAME = '房东姓名',
  LANDLORD_PHONE = '房东电话',
  RENT = '租金',
  MOVE_IN_DATE = '搬入日期',
  MOVE_OUT_DATE = '搬出日期',
  I_HAVE_READ_AND_AGREED_TO_THE_TERMS = '我已阅读并同意服务条款',
  ADD_EMPLOYMENT = '添加就业',
  EMPLOYMENT_HISTORY = '就业历史',
  I_AM_EMPLOYED = '我目前有工作',
  ANNUAL_INCOME = '年收入',
  NAME = '姓名',
  PHONE = '电话',
  POSITION = '职位',
  JOB_TITLE = '职位',
  SALARY = '薪水',
  START_SCREENING = '开始筛选',
  PAYMENT_DETAILS = '支付详情',
  SUBMIT_ANSWERS = '提交答案',
  PAYMENT_PROCESSING = '支付处理 ...',
  PAYMENT_PROCESSING_BLURB = '您的交易正在处理。这可能需要几分钟。请耐心等待，不要关闭屏幕',
  DONE = '完成',
  SUBMITTED = '已提交',
  RENTAL_APPLICATION_SUCCESSFULLY_SUBMITTED = '恭喜——您的申请已成功提交！',
  RENTAL_APPLICATION_NOTIFICATION = '我们会尽快与您联系。',
  CONNECTING_TO_TRANS_UNION = '连接到TransUnion准备问卷并启动身份验证 ...',
  CONNECTING_TO_TRANS_UNION_BLURB = '请耐心等待，不要离开此页面 - 我们正在安全地获取您的问卷并设置身份验证。',
  CONTACT_CUSTOMER_SUPPORT = '为了完成您的筛选过程，请联系我们的客户支持',
  CONTACT_CUSTOMER_SUPPORT_BLURB = '在通话期间，请保持在此屏幕上以获取实时更新。一旦您的通话结束，请留在页面上进行下一步。',
  UNABLE_TO_VERIFY_IDENTITY = '我们无法在线验证您的身份。',
  RENTER_SCREENING_ID = '租户筛选ID= {renterID}',
  PAGE_NOT_FOUND = '页面未找到',
  PAGE_NOT_FOUND_BLURB_1 = '看起来您找到了通向伟大虚无的门，很抱歉。',
  PAGE_NOT_FOUND_BLURB_2 = '请访问我们的主页以到达您需要的地方。',
  COMPANY_NOT_FOUND = '看起来您正在寻找的页面不存在。请检查URL或联系您的物业经理以获取帮助。',
  FIRST_NAME = '名字',
  LAST_NAME = '姓氏',
  SSN = 'SSN',
  DATE_OF_BIRTH = '出生日期',
  VIEW_IN_FULL_SCREEN = '在新标签页中打开',
  WELCOME = '欢迎',
  YOU_HAVE_TO_ACCEPT_THIS_LICENSE_AGREEMENT = '您必须接受此许可协议',
  PAY = '支付',
  RENTAL_APPLICATION_FEE_BLURB = '您需要支付 {amount} 的不可退还费用来提交您的申请，这将用于筛选成本。',
  TEXT_ONLY = '仅文本',
  LEASING = '租赁',
  CONFIRM = '确认',
  END_DATE_IS_INVALID = '结束日期无效',
  FIRST_NAME_IS_INVALID = '名字无效',
  LAST_NAME_IS_INVALID = '姓氏无效',
  EMAIL_IS_INVALID = '邮箱无效',
  PHONE_NUMBER_IS_INVALID = '电话号码无效',
  DATE_OF_BIRTH_IS_INVALID = '出生日期无效',
  DATE_OF_BIRTH_IS_GREATER = '年龄不能大于125岁',
  DATE_OF_BIRTH_IS_LESSER = '年龄不能小于18岁',
  ANNUAL_INCOME_IS_INVALID = '年收入无效',
  SSN_IS_INVALID = 'SSN无效',
  EMPLOYER_NAME_IS_INVALID = '雇主姓名无效',
  SALARY_IS_INVALID = '薪水无效',
  POSITION_TITLE_IS_INVALID = '职位/标题无效',
  START_DATE_IS_INVALID = '开始日期无效',
  END_DATE_IS_INVALID_EARLIER = '结束日期不能早于开始日期',
  ADDRESS_IS_INVALID = '地址无效',
  STREET_ADDRESS_1_IS_INVALID = '街道地址1无效',
  STREET_ADDRESS_2_IS_INVALID = '街道地址2无效',
  REASON_FOR_LEAVING_IS_INVALID = '离开原因不能超过500个字符',
  CITY_IS_INVALID = '城市无效',
  STATE_IS_INVALID = '州无效',
  ZIP_CODE_IS_REQUIRED = '邮编必填',
  ZIP_CODE_IS_INVALID = '美国邮编必须由5位数字组成',
  COUNTRY_IS_INVALID = '国家无效',
  LANDLORD_NAME_IS_INVALID = '房东姓名无效',
  LANDLORD_PHONE_NUMBER_IS_INVALID = '房东电话号码无效',
  RENT_IS_INVALID = '租金无效',
  MOVE_IN_DATE_IS_INVALID = '搬入日期无效',
  MOVE_OUT_DATE_IS_INVALID = '搬出日期无效',
  MOVE_IN_DATE_IS_LATER = '搬入日期不能晚于搬出日期',
  MOVE_OUT_DATE_IS_EARLIER = '搬出日期不能早于搬入日期',
  JOB_TITLE_IS_INVALID = '职位/标题无效',
  FILE_IS_REQUIRED = '文件必填',
  COMPANY_NAME = '公司名称',
  FOLLOW_US = '关注我们',
  PROPERTIES = '物业',
  CONTACT_US = '联系我们',
  LET_US_GUIDE_YOU_HOME = '让我们引导你的家',
  BANNER_TITLE = '发现一个你喜欢的家',
  SEARCH = '搜索',
  PROPERTY_FOR_YOU_TITLE = '为你准备的物业',
  PROPERTY_FOR_YOU_SUBTITLE = '搜索并保存几个你喜欢的房子，我们会为你推荐。',
  PINNED = '固定',
  PRICE = '价格',
  MIN = '最小',
  MAX = '最大',
  NO_MIN = '没有最小',
  NO_MAX = '没有最大',
  HOME_TYPE = '房屋类型',
  BEDS_AND_BATHS = '卧室和浴室',
  ANY = '任何',
  SINGLE_FAMILY = '单户家庭',
  MULTI_FAMILY = '多户家庭',
  COMMERCIAL = '商业',
  CONDO = '公寓',
  TOWN_HOUSE = '联排别墅',
  RESET = '重置',
  CONTACT_MANAGER = '联系经理',
  PET = '宠物',
  PETS = '宠物',
  AC = '空调',
  PARKING = '停车位',
  UTILITIES_INCLUDED = '包含水电费',
  INTERIOR_AMENITIES = '内部设施',
  OUTDOOR_AMENITIES = '外部设施',
  COMMUNITY_AMENITIES = '社区设施',
  OUTDOOR = '户外',
  LISTED = '已列出',
  MONTH = '月',
  SQFT = '平方英尺',
  OVERVIEW = '概览',
  HOME_HIGHLIGHTS = '家亮点',
  FACTS_AND_FEATURES = '事实和功能',
  LOCAL_INFORMATION = '本地信息',
  SELECT_PRICE = '选择价格',
  SELECT_HOME_TYPE = '选择房屋类型',
  SELECT_MOVE_IN_DATE = '选择搬入日期',
  SLIDE_UP_TO_LOAD_MORE = '上滑加载更多',
  APPLY = '应用',
  PROPERTY_DETAIL = '物业详情',
  ZERO_RESULTS_DESC = '没有找到给定地址的结果。请检查地址并重试。',
  MAP_ERROR_DESC = '加载地图时发生错误。请稍后再试。',
  SEARCH_FOR_YOUR_DREAM_HOME = '搜索你的梦想之家',
  ALL_RIGHTS_RESERVED = '所有权利保留',
  DBA_TENANT_FRIENDLY_NAME = '“{companyName}”是一个便于租户识别的名称，实际以下列法律实体开展业务：',
  DBA_ALSO_OPERATES_AS = '“{companyName}”同时也以下列法律实体开展业务：',
  DBA_ENTITY_MAY_VARY = '具体的法律责任实体可能因您所租住或申请的楼宇而有所不同。',
  WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABLE_UNITS = '我们目前没有可用的单位，但您总是欢迎提交租赁申请给我们',
  PRIVACY_POLICY = '隐私政策',
  ACCEPT_TERMS_AND_CONDITIONS_PROCEED = '请接受条款和条件以继续。',
  TERMS_OF_SERVICE = '服务条款',
  EQUAL_HOUSING_OPPORTUNITY = '平等住房机会',
  FILTER = '过滤器',
  FILTERS = '过滤器',
  SIGN_HERE = '在这里签名！',
  ALLOWED = '允许',
  MONTHLY_PET_FEES = '每月宠物费用',
  NO_LIMIT = '没有限制',
  PET_DEPOSIT = '宠物押金',
  SMALL_WEIGHT = '小（小于22.0462磅）',
  MEDIUM_WEIGHT = '中（22.0462 - 55.1156磅）',
  LARGE_WEIGHT = '大（55.1156 - 110.2311磅）',
  CATS = '猫',
  DOGS = '狗',
  OTHER = '其他',
  FISH = '鱼',
  BIRDS = '鸟',
  REPTILES = '爬行动物',
  OTHERS = '其他',
  ALL_ALLOWED = '所有允许',
  DESIRED_MOVE_IN_DATE_IS_INVALID = '期望搬入日期无效',
  DESIRED_MOVE_IN_DATE = '期望搬入日期',
  CURRENT_UNIT_IS_UNLISTED = '您当前申请的房源已下架。',
  PLEASE_ANSWER_THIS_QUESTION = '请回答这个问题',
  COMMENT_CANNOT_EXCEED = '评论不能超过500个字符',
  YOU_CAN_ADD_A_COMMENT_TO_THE_MANAGER = '您可以添加评论给经理',
  COMMENT = '评论',
  PET_NAME_IS_INVALID = '宠物名称无效',
  BREED_IS_INVALID = '品种无效',
  PET_WEIGHT_IS_INVALID = '宠物重量无效',
  AGE_IS_INVALID = '年龄无效',
  GENDER_IS_INVALID = '性别无效',
  SPAY_NEUTER_STATUS_IS_INVALID = '绝育状态无效',
  SERVICE_ANIMAL_STATUS_IS_INVALID = '服务动物状态无效',
  EMOTIONAL_SUPPORT_ANIMAL_STATUS_IS_INVALID = '情感支持动物状态无效',
  CAR_MAKE_IS_INVALID = '车辆制造商无效',
  MODEL_IS_INVALID = '型号无效',
  YEAR_IS_INVALID = '年份无效',
  LICENSE_PLATE_IS_INVALID = '车牌无效',
  STATE_REGISTRATION_IS_INVALID = '州注册无效',
  CAR_COLOR_IS_INVALID = '车辆颜色无效',
  YOU_HAVE_SUCCESSFULLY_SIGNED_THE_LEASE = '您已成功签署租赁协议。请留意我们未来的消息。',
  BREED = '品种',
  WEIGHT = '重量',
  AGE = '年龄',
  GENDER = '性别',
  CAR = '车',
  CARS = '汽车',
  CAR_MAKE = '车辆制造商',
  MODEL = '型号',
  YEAR = '年份',
  LICENSE_PLATE = '车牌',
  STATE_REGISTRATION = '州注册',
  COLOR = '颜色',
  SPAYED_OR_NEUTERED = '我的宠物已绝育/绝育',
  SERVICE_ANIMAL = '我的宠物是服务动物',
  EMOTIONAL_SUPPORT_ANIMAL = '我的宠物是情感支持动物',
  MM_DD_YYYY = 'MM/DD/YYYY',
  OPERATION_FAILED_PLEASE_TRY_AGAIN_LATER = '操作失败，请稍后再试',
  REMOVE_SELECTED = '删除选中',
  PURCHASE_RENTAL_INSURANCE = '购买租赁保险',
  UNAVAILABLE = '文档未找到',
  DOCUMENT_NOT_AVAILABLE = '文档已不可用。请联系您的物业经理获取帮助。',
  LINK_EXPIRED_TITLE = '链接已过期',
  LINK_EXPIRED_MESSAGE = '此链接已过期。请联系您的物业经理以获取最新的文档副本。',
  DO_YOU_HAVE_A_PET = '您有宠物吗？',
  ADD_NEW_PET = '添加新宠物',
  DO_YOU_HAVE_A_CAR = '您有车吗？',
  ADD_NEW_CAR = '添加新车',
  NO_UNITS_LISTED = '目前，没有单位列出',
  OR_LESS = '或更少',
  OR_MORE = '或更多',
  LIST_SEPARATOR = '{first}、{rest}',
  PRICE_OR_MORE = '{price}或更多',
  PRICE_OR_LESS = '{price}或更少',
  PRICE_RANGE = '{min}-{max}',
  MIN_BEDS = '{count}+ 卧室',
  MIN_BATHS = '{count}+ 浴室',
  MOVE_IN_DATE_FROM = '搬入日期 {date}',
  PETS_ALLOWED_TYPES = '允许（{types}）',
  MONTHLY_PET_FEES_AMOUNT = '{amount} 每月宠物费用',
  PET_DEPOSIT_AMOUNT = '宠物押金：{amount}',
  ANY_PRICE = '任何价格',
  NO_MORE_RESULTS = '没有更多结果',
  BY_SUBMITTING_THIS_APPLICATION_BLURB = `通过提交此表格，您同意{companyName}在提供的号码上向您发送账户通知和公司直接通信消息，包括通过自动拨号器发送的消息。消息频率可能会有所不同。同意不是购买的条件。可能会收取消息和数据费用。随时回复STOP取消订阅。回复HELP获取帮助。 `,
  SEARCH_UNITS = '搜索单位...',
  SEARCH_ADDRESS = '搜索地址',
  LANDLORD_EMAIL = '房东邮箱',
  LANDLORD_EMAIL_REQUIRED_FOR_CONSENT = '需要房东邮箱才能验证您的租房记录',
  VERIFICATION_CONSENT = '我同意 {companyName} 联系此房东以核实我的租房记录。',
  SUPPORTING_DOCUMENTS = '证明文件',
  OOPS = '哎呀！',
  APPLICATION_NOT_QUALIFIED_TITLE = '申请信息不完整',
  APPLICATION_NOT_QUALIFIED_BODY = '请在提交前完成以下内容：',
  VALIDATION_FIRST_NAME_REQUIRED = '请填写名字',
  VALIDATION_LAST_NAME_REQUIRED = '请填写姓氏',
  VALIDATION_EMAIL_REQUIRED = '请填写电子邮箱',
  VALIDATION_PHONE_REQUIRED = '请填写电话号码',
  VALIDATION_SSN_REQUIRED = '请填写社会安全号码（SSN）',
  VALIDATION_DATE_OF_BIRTH_REQUIRED = '请填写出生日期',
  VALIDATION_RESIDENTIAL_HISTORY_REQUIRED = '请至少填写一条居住历史记录',
  VALIDATION_REQUIRED_QUESTIONS_NOT_ANSWERED = '提交申请前必须回答所有必填问题',
  VALIDATION_ALREADY_SUBMITTED = '此申请已提交',
  VALIDATION_REQUIRED_FILES_MISSING = '缺少必需的文件',
  VALIDATION_TERMS_NOT_ACCEPTED = '尚未接受条款',
  APPLY_NOW = '立即申请',
  SUMMARY = '摘要',
  APPLICATION_EDIT_WARNING = '提交后您将无法编辑申请。请在继续之前仔细查看您的信息。',
  APPLICATION_LOCKED_WARNING = '申请已提交并已锁定。无法对先前输入的数据进行任何更改。',
  EDIT = '编辑',
  CHANGE = '更改',
  UNIT = '单元',
  SPECIAL_INFO = '特殊信息',
  MAKE_AND_MODEL = '制造商和型号',
  EMPLOYMENT = '就业记录',
  EMPLOYMENT_HISTORY_REQUIRED = '请至少添加一条工作记录',
  TEXT_TOO_LONG = '文本不能超过500个字符',
  PERMISSION_TO_TEXTING_NOTICE = '注意：不选中此框可能会阻止您收到有关租赁申请的重要更新。如果您对此感到满意，只需再次单击“下一步”即可继续。',
  COULD_NOT_LOAD_PDF_FILE = '无法加载PDF文件！',
  WATER_AND_SEWER = '水电和下水道',
  ELECTRICITY = '电力',
  GAS = '天然气',
  TRASH = '垃圾处理',
  INTERNET_CABLE = '网络/有线电视',
  HEATING_AIR_CONDITIONING = '供暖/空调',
  IN_UNIT_WASHER_DRYER = '室内洗衣机/烘干机',
  DISHWASHER = '洗碗机',
  MICROWAVE = '微波炉',
  STAINLESS_STEEL_APPLIANCES = '不锈钢电器',
  HARDWOOD_FLOORING = '硬木地板',
  CENTRAL_AC_HEATING = '中央空调/供暖',
  WALK_IN_CLOSETS = '步入式衣橱',
  HIGH_SPEED_INTERNET = '高速网络',
  FIREPLACE = '壁炉',
  PATIO = '露台',
  BBQ_GRILLS_OR_PICNIC_AREA = '烧烤架或野餐区',
  ROOFTOP_DECK = '屋顶甲板',
  PARKING_SPACE = '停车位',
  GYM = '健身房',
  SWIMMING_POOL = '游泳池',
  COMMUNITY_CLUBHOUSE = '社区会所',
  PLAYGROUND_OR_DOG_PARK = '游乐场或狗狗公园',
  LAUNDRY_FACILITIES = '洗衣设施',
  PARKING_OR_GARAGE = '停车场或车库',
  SECURITY_OR_CONTROLLED_ACCESS = '24小时安保或门禁系统',
  E_SIGNATURE_CONSENT_TITLE = '电子记录和签名披露',
  E_SIGNATURE_CONSENT_BODY = '选择"我同意"即表示我同意以电子方式进行业务，包括使用电子签名签署文件。我确认已阅读并同意电子签名的使用条款。',
  E_SIGNATURE_CONSENT_AGREE = '我同意使用电子记录和签名',
  E_SIGNATURE_CONSENT_ERROR = '您必须同意电子签名条款才能继续',
  E_SIGNATURE_DISCLOSURE_LINK = '查看完整的电子记录和签名披露',
  START_SIGNING = '开始签名',
  FILE_KIND_GOVERNMENT_ID = '政府身份证件',
  FILE_KIND_BANK_STATEMENT = '银行对账单',
  FILE_KIND_PAY_STUB = '工资单',
  FILE_KIND_TAX_RETURN = '纳税申报表',
  FILE_KIND_OFFER_LETTER = '录用通知书',
  FILE_KIND_REFERENCE_LETTER = '推荐信',
  FILE_KIND_EMPLOYMENT_VERIFICATION = '在职证明',
  FILE_KIND_OTHER = '其他文件',
  UPLOADING_FILE_PROGRESS = '正在上传 {current} / {total}：{fileName}',
  TERMS_ACCEPTED_AT = '已于 {date} 接受',
  VERIFYING_YOUR_IDENTITY = '正在验证您的身份，请稍候……',
  FETCHING_FROM_TRANSUNION = '正在从 TransUnion 获取数据',
  LOADING_APPLICATION = '正在加载您的申请……',
  LOADING_PAYMENT_FINALIZING = '正在等待付款完成……',
  LOADING_PAYMENT_INFO = '正在加载支付信息……',
  LOADING_TAKING_LONGER = '加载时间比预期更长。如果长时间未完成，请联系客服。',
  SUBMIT_BLOCKED_MAGICDOOR_TERMS = '请接受 MagicDoor 服务条款以继续。',
  SUBMIT_BLOCKED_TRANSUNION_TERMS = '请接受 TransUnion 服务条款以继续。',
  SUBMIT_BLOCKED_MISSING_REQUIRED_FIELDS = '请补全申请中剩余的必填字段。',
  SUBMIT_BLOCKED_HEADING = '提交前请处理：',
  MISSING_REQUIRED_DOCUMENT = '请上传必需文件：{name}',
  NUMBERED_ITEM = '{label} {number}',
  UPLOADING_FILE_COUNT = '正在上传 {current}/{total}',
  GENDER_MALE = '公',
  GENDER_FEMALE = '母',
  APPLICATION_STATUS_DRAFT = '草稿',
  APPLICATION_STATUS_RETRACTED = '已撤回',
  JOB_AT_EMPLOYER = '{employer} 的 {jobTitle}',
  SPAYED_NEUTERED_LABEL = '已绝育',
  SERVICE_ANIMAL_LABEL = '服务动物',
  EMOTIONAL_SUPPORT_ANIMAL_LABEL = '情感支持动物',
  UPLOAD_REQUIRED_DOCUMENTS = '必需文件',
  INFO_UPDATE_MODE_BADGE = '请求更新',
  INFO_UPDATE_BADGE_HINT = '{companyName} 已请您审核并更新您的申请。',
  INFO_UPDATE_WELCOME = '欢迎',
  INFO_UPDATE_WELCOME_TITLE = '更新您的申请',
  INFO_UPDATE_WELCOME_BODY = '{companyName} 请您审核并更新申请的部分内容。请使用左侧菜单编辑任何部分。您的更改将随时保存。完成后，请点击"完成"。',
  INFO_UPDATE_WELCOME_GET_STARTED = '开始',
  INFO_UPDATE_PERSONAL_INFORMATION = '个人信息',
  INFO_UPDATE_DONE = '完成',
  INFO_UPDATE_DONE_PROMPT = '更新完成？点击"完成"通知 {companyName} 您的更改已就绪。',
  INFO_UPDATE_DONE_CONFIRM_TITLE = '提交您的更改？',
  INFO_UPDATE_DONE_CONFIRM_BODY = '提交后，此更新链接将无法再使用。如需继续修改，{companyName} 需要发送新的代码。',
  INFO_UPDATE_DONE_CONFIRM_OK = '提交',
  INFO_UPDATE_DONE_CONFIRM_CANCEL = '继续编辑',
  INFO_UPDATE_THANK_YOU_TITLE = '谢谢 — 您的更新已提交',
  INFO_UPDATE_THANK_YOU_BODY = '{companyName} 将审核您的更改。您可以关闭此窗口。',
  INFO_UPDATE_ERROR_LOCKED = '此更新链接已无效。请联系 {companyName} 获取新链接。',
  INFO_UPDATE_ERROR_EXPIRED = '此更新链接已过期。请联系 {companyName} 获取新链接。',
  INFO_UPDATE_ERROR_INVALID = '此更新链接无效。请联系 {companyName} 寻求帮助。',
  INFO_UPDATE_ERROR_COMPLETED = '此更新已提交。无需再做更改。',
  INFO_UPDATE_ERROR_CANCELLED = '此更新链接已被 {companyName} 取消。如仍需修改，请联系他们。',
  INFO_UPDATE_ERROR_UNCERTAIN = '我们无法确认此链接是否仍然有效。您可以继续编辑，但如果链接已被使用或过期，您的更改可能无法保存。如需新链接，请联系物业经理。',
  INFO_UPDATE_REFRESH_TO_VERIFY = '刷新以验证',
  LANDLORD_VERIFICATION_TITLE = '租赁历史验证',
  LANDLORD_VERIFICATION_INTRO = '请确认 {applicantName} 的以下租赁历史。',
  LANDLORD_VERIFICATION_APPLICANT = '申请人',
  LANDLORD_VERIFICATION_ADDRESS = '地址',
  LANDLORD_VERIFICATION_MOVE_IN = '入住日期',
  LANDLORD_VERIFICATION_MOVE_OUT = '搬出日期',
  LANDLORD_VERIFICATION_RESPONSE = '您的回复',
  LANDLORD_VERIFICATION_VERIFIED = '已确认',
  LANDLORD_VERIFICATION_DECLINED = '拒绝',
  LANDLORD_VERIFICATION_REJECTED = '驳回',
  LANDLORD_VERIFICATION_NOTES = '备注（可选）',
  LANDLORD_VERIFICATION_HAD_LATE_PAYMENTS = '租客有逾期付款',
  LANDLORD_VERIFICATION_WAS_EVICTED = '租客被驱逐',
  LANDLORD_VERIFICATION_WOULD_RECOMMEND = '愿意推荐此租客',
  LANDLORD_VERIFICATION_SUBMIT = '提交回复',
  LANDLORD_VERIFICATION_SUBMITTING = '正在提交...',
  LANDLORD_VERIFICATION_THANK_YOU_TITLE = '谢谢',
  LANDLORD_VERIFICATION_THANK_YOU_BODY = '您的回复已记录。',
  LANDLORD_VERIFICATION_ALREADY_COMPLETE_TITLE = '此验证已完成',
  LANDLORD_VERIFICATION_ALREADY_COMPLETE_BODY = '此链接已被用于提交回复。',
  LANDLORD_VERIFICATION_INVALID_LINK_TITLE = '链接未找到',
  LANDLORD_VERIFICATION_INVALID_LINK_BODY = '此验证链接无效或已过期。',
  LANDLORD_VERIFICATION_MAGIC_RIBBON = '通过 MagicDoor 进行验证 — {companyName} 使用的 AI 原生物业管理平台。',
  LANDLORD_VERIFICATION_MAGIC_FOOTER_TITLE = '{companyName} 使用 MagicDoor',
  LANDLORD_VERIFICATION_MAGIC_FOOTER_BODY = 'AI 原生的物业管理平台 — 租赁、维护和会计一体化。前 10 个租约免费。',
  LANDLORD_VERIFICATION_MAGIC_LEARN_MORE = '了解更多',
  LANDLORD_VERIFICATION_MAGIC_THANK_YOU_TITLE = '厌倦了通过邮件追踪房东验证？',
  LANDLORD_VERIFICATION_MAGIC_THANK_YOU_BODY = 'MagicDoor 自动化此流程 — 以及物业管理的其他工作。AI 处理琐事，让您专注于租客。前 10 个租约免费。',
  LANDLORD_VERIFICATION_MAGIC_TRY_FREE = '免费试用 MagicDoor',
  LANDLORD_VERIFICATION_VERIFIER_NAME = '您的姓名',
  LANDLORD_VERIFICATION_VERIFIER_NAME_HINT = '有助于我们的记录',
  LANDLORD_VERIFICATION_WANTS_MAGICDOOR_INFO = '我想了解 MagicDoor 用于我自己物业的更多信息。',
  LANDLORD_VERIFICATION_SUBMITTED_BY = '由 {verifierName} 提交',
  LANDLORD_VERIFICATION_YOUR_PROPERTY_MANAGER = '您的物业管理公司',
  LANDLORD_VERIFICATION_RESPONSE_REQUIRED = '提交前请选择一个答复。',
  INSURANCE_LINK_NOT_FOUND = '无法加载保险报价。请刷新页面后重试。',
  CO_APPLICANTS_STEP_LABEL = '共同申请人',
  CO_APPLICANTS_TITLE = '邀请共同申请人',
  CO_APPLICANTS_INTRO = '如果有其他人与您一起租住，请邀请他们填写自己的申请部分。您也可以跳过此步骤继续。',
  CO_APPLICANTS_LIST_HEADING = '已邀请',
  CO_APPLICANTS_NONE_INVITED = '您还未邀请任何人。',
  CO_APPLICANTS_ADD_HEADING = '添加共同申请人',
  CO_APPLICANTS_FIRST_NAME = '名',
  CO_APPLICANTS_LAST_NAME = '姓',
  CO_APPLICANTS_EMAIL = '电子邮箱',
  CO_APPLICANTS_EMAIL_HINT = '发送邀请所需',
  CO_APPLICANTS_PHONE = '电话',
  CO_APPLICANTS_MESSAGE = '个人留言（可选）',
  CO_APPLICANTS_SEND_INVITE = '发送邀请',
  CO_APPLICANTS_SENDING = '发送中...',
  CO_APPLICANTS_INVITE_FAILED = '邀请发送失败，请重试。',
  CO_APPLICANTS_NO_EMAIL_NOTE = '未提供邮箱 — 邀请将不会自动发送。',
  SIGNING_OFFERS_DW_TITLE = '请注意：损害豁免适用于本租约',
  SIGNING_OFFERS_DW_SUBTITLE = '来自物业经理的信息——此刻无需任何操作。',
  SIGNING_OFFERS_DW_NOTE = '物业经理已启用损害豁免计划。由于系统中没有有效的租客保险，宽限期结束后将自动开始收费。你可以随时上传租客保险保单以避免此项费用。',
  SIGNING_OFFERS_DW_MONTHLY_FEE = '每月豁免费',
  SIGNING_OFFERS_DW_BILLING_STARTS = '开始计费',
  SIGNING_OFFERS_DW_BILLING_AFTER = '{date} 之后',
  SIGNING_OFFERS_DW_STATUS = '状态',
  SIGNING_OFFERS_DW_ENROLLED = '当前已加入',
  SIGNING_OFFERS_DW_OPTED_OUT_TITLE = '损害豁免资格',
  SIGNING_OFFERS_DW_OPTED_OUT_BODY = '你此前已退出损害豁免计划。如果希望重新适用该计划，可以恢复资格。',
  SIGNING_OFFERS_DW_RESTORE = '恢复资格',
  SIGNING_OFFERS_DW_RESTORED_TITLE = '资格已恢复',
  SIGNING_OFFERS_DW_RESTORED_BODY = '当计划下次审核资格时，你的租约可以重新进入损害豁免流程。这并不表示你已加入或已获得保障。',
  SIGNING_OFFERS_RBP_TITLE = '住户福利，可供你选择',
  SIGNING_OFFERS_RBP_SUBTITLE = '由物业经理提供。可选——仅在你需要这些福利时加入。',
  SIGNING_OFFERS_RBP_PRICE_HINT = '价格在确认时显示',
  SIGNING_OFFERS_RBP_JOIN = '加入',
  SIGNING_OFFERS_RBP_JOINED = '已加入',
  SIGNING_OFFERS_RBP_FOOTNOTE = '通过租金账户按月计费 · 承诺期结束后可随时取消',
  SIGNING_OFFERS_RBP_NO_THANKS = '不用了',
  SIGNING_OFFERS_RBP_CONFIRM_TITLE = '加入 {name}？',
  SIGNING_OFFERS_RBP_JOINED_TITLE = '已加入 {name}',
  SIGNING_OFFERS_RBP_CONFIRM_JOIN = '确认并加入',
  SIGNING_OFFERS_RBP_LOADING_QUOTE = '正在加载当前条款…',
  SIGNING_OFFERS_RBP_NOT_AVAILABLE = '当前不可加入',
  SIGNING_OFFERS_RBP_MONTHLY_AMOUNT = '每月金额',
  SIGNING_OFFERS_RBP_BENEFITS_START = '福利开始',
  SIGNING_OFFERS_RBP_COMMITMENT_ENDS = '承诺结束',
  SIGNING_OFFERS_RBP_CHARGED_VIA = '扣款方式',
  SIGNING_OFFERS_RBP_RENT_ACCOUNT = '你的租金账户',
  SIGNING_OFFERS_RBP_LOCK_NOTE = '首次扣款稍后发生——今天不会产生费用。此确认展示你确认时的当前条款。',
  SIGNING_OFFERS_PER_MONTH = '{amount} / 月',
  RESIDENT_BENEFIT_REASON_UNAVAILABLE = '此套餐当前不可用。',
  RESIDENT_BENEFIT_REASON_LEASE_NOT_ACTIVE = '此套餐仅在租约生效时可用。',
  RESIDENT_BENEFIT_REASON_NO_LONGER_OFFERED = '此套餐已不再向您的租约提供。',
  RESIDENT_BENEFIT_REASON_ALREADY_JOINED = '您已加入此套餐。',
  COMPANY_LOGO = '公司标志',
}
